import type { IconNode } from 'lucide-react'
import { createLucideIcon } from 'lucide-react'

export const __iconNode: IconNode = []

const IpdEmpty = createLucideIcon('ipd-empty', __iconNode)
export default IpdEmpty
